import React, { useContext, useEffect } from 'react';
import "../Styles/forgetpassword.css"
import Typography from '@mui/material/Typography';
import "../Styles/style.css"
import { Card } from '@mui/material';
import succses from '../images/gif_success.gif';
import { useLocation, useNavigate } from 'react-router-dom';
import { LanguageContext } from '../language/LanguageContext';
import { activation_request_url } from '../Utilities/apiUrl';


interface ActionMessage {
  mainText: string;
  linkText: string;
  mainTextLink: string;
  isDisplayImg: boolean;
}

const ActionMessage: React.FC<ActionMessage> = ({ mainText, linkText, mainTextLink, isDisplayImg }) => {
  const { getTranslation } = useContext(LanguageContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const channel = searchParams.get('channel');
  const token = searchParams.get('token');
  const temptoken = searchParams.get('temptoken');
  const navigate = useNavigate();

  const handleClick = () => {

    if (location.pathname === '/processregister') {
          navigate(`/loginregister?channel=${channel}&temptoken=${temptoken}`);
    }
    else{
      switch (channel) {
        case 'online':
          window.location.href = "https://online.lupa.co.il/create/naming"
          break;
        case 'calendar':
          window.location.href = "https://calendarv4-ui.lupa.co/feed"
          break;
        default:
          window.location.href = "https://www.lupa.co.il/"
  
        // Handle default case if needed
      }
    }
  };


  const activation_request = async () => {
    if (location.pathname === '/succsesregister') {
      const data = await fetch(`${activation_request_url}&token=${token}&channel=${channel}`);
      const response = await data.json();

      if (!response.isValid) {
        //window.location.reload();
      }
    }
  };
  useEffect(() => {
    activation_request();
  }, []);

  return (
    <Card className="card card-login">
      <div className='display-fp'>
        <Typography component="h1" className='typography-fp'>{getTranslation(mainText)}</Typography>
        {
          <>          
           {isDisplayImg ? <div  className='typography-sm-fp'>
              <img style={{width:'140px'}} src={succses} alt="gif" /> {/* Your image here */}
            </div>
            :
            <div className='typography-sm-fp'>
            {mainTextLink}
         </div>  
            }
            <button
              type="button"
              onClick={handleClick}
              className='typography-sm-fp-link typography-sm-fp-link-button'
            >
              {getTranslation(linkText)}
            </button>
          </>
        }

      </div>
    </Card>
  );
}
export default ActionMessage;
